import React from 'react'
import PropTypes from 'prop-types'
import { Table, Button, Tooltip, message, Spin } from 'antd'
import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons'
import moment from 'moment'

export default class Revisions extends React.PureComponent {

  static propTypes = {
    ramsRecordId: PropTypes.number,
    revisions: PropTypes.array,
    loading: PropTypes.bool,
    onFetchRevisions: PropTypes.func.isRequired,
  }

  static defaultProps = {
    ramsRecordId: null,
    revisions: [],
    loading: false,
  }

  componentDidMount() {
    const { ramsRecordId, onFetchRevisions } = this.props
    if (ramsRecordId) {
      onFetchRevisions(ramsRecordId)
    }
  }

  componentDidUpdate(prevProps) {
    const { ramsRecordId, onFetchRevisions } = this.props
    if (ramsRecordId && ramsRecordId !== prevProps.ramsRecordId) {
      onFetchRevisions(ramsRecordId)
    }
  }

  handleDownload = (url) => {
    if (url) {
      window.open(url, '_blank')
    } else {
      message.warning('PDF snapshot not available for this revision')
    }
  }

  render() {
    const { revisions, loading } = this.props
    const self = this

    const columns = [
      {
        title: 'Rev #',
        key: 'index',
        width: 80,
        render: (text, record, index) => {
          return <span style={{ fontWeight: 'bold' }}>{index + 1}</span>
        },
      },
      {
        title: 'Date & Time',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 150,
        render: (text) => {
          return text ? moment(text, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm') : '-'
        },
      },
      {
        title: 'User',
        dataIndex: 'user_name',
        key: 'user_name',
        width: 150,
      },
      {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
      },
      {
        title: 'PDF',
        key: 'download',
        width: 80,
        align: 'center',
        render: (text, record) => {
          if (record.has_snapshot && record.snapshot_pdf_url) {
            return (
              <Tooltip title="Download PDF snapshot">
                <Button
                  type="link"
                  icon={<DownloadOutlined />}
                  onClick={() => self.handleDownload(record.snapshot_pdf_url)}
                />
              </Tooltip>
            )
          }
          return (
            <Tooltip title="PDF snapshot not available">
              <FileTextOutlined style={{ color: '#ccc', fontSize: 16 }} />
            </Tooltip>
          )
        },
      },
    ]

    if (loading) {
      return (
        <div style={{ padding: '40px 0', textAlign: 'center' }}>
          <Spin />
        </div>
      )
    }

    if (!revisions || revisions.length === 0) {
      return (
        <div style={{ padding: '40px 0', textAlign: 'center', color: '#999' }}>
          No revisions found
        </div>
      )
    }

    return (
      <div style={{ padding: '16px 0' }}>
        <Table
          dataSource={revisions}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </div>
    )
  }
}
